import { format, formatDistanceToNowStrict } from "date-fns";

// Format constants
export const DATE_FORMAT = "MMM d, yyyy";
export const TIME_FORMAT = "h:mm a";
export const DATETIME_FORMAT = "MMM d, yyyy · h:mm a";
export const DATE_FULL_FORMAT = "EEEE, MMMM d, yyyy";
export const DATE_ISO_FORMAT = "yyyy-MM-dd";
export const TIME_24H_FORMAT = "HH:mm";
export const DATE_SHORT_FORMAT = "MMM d";
/** Weekday + date, for a meta line that must say WHICH day without spending a row on it. */
export const DATE_COMPACT_FORMAT = "EEE, MMM d";

/** Parse a value as a Date; date-only strings (`YYYY-MM-DD`) are read as local to avoid UTC drift. */
function toLocalDate(d: string | Date): Date {
  if (typeof d === "string") {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d);
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  return new Date(d);
}

// Formatter helpers
export const formatDate = (d: string | Date) => format(toLocalDate(d), DATE_FORMAT);
export const formatTime = (d: string | Date) => format(new Date(d), TIME_FORMAT);
export const formatDateTime = (d: string | Date) => format(new Date(d), DATETIME_FORMAT);
export const formatDateFull = (d: string | Date) => format(new Date(d), DATE_FULL_FORMAT);
export const formatDateCompact = (d: string | Date) => format(toLocalDate(d), DATE_COMPACT_FORMAT);

/** "2m ago", "1h ago", "yesterday", etc. */
export function formatRelativeTime(d: string | Date): string {
  const date = new Date(d);
  const diffMs = Date.now() - date.getTime();
  if (diffMs < 60_000) return "just now";
  return `${formatDistanceToNowStrict(date)} ago`;
}

/** Compact relative time — "now", "2m", "5h", "3d", "2w", "1y". */
export function formatCompactRelativeTime(d: string | Date): string {
  const s = Math.max(0, Math.floor((Date.now() - new Date(d).getTime()) / 1000));
  if (s < 60) return "now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  const days = Math.floor(h / 24);
  if (days < 7) return `${days}d`;
  const w = Math.floor(days / 7);
  if (w < 52) return `${w}w`;
  return `${Math.floor(days / 365)}y`;
}
